export default {"src":"/uk/_next/static/media/spot-expert.6461f219.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};